import { PropertySafetyOutlined } from '@ant-design/icons'

import { RouteItem } from '@eastcoal/router/types/route'

import { DEPOSIT_PAGE } from './uuid'

export const depositRoute: RouteItem = {
  title: '保证金审批',
  uuid: DEPOSIT_PAGE,
  path: '/deposit',
  icon: <PropertySafetyOutlined />,
  Component: () => import('./index')
}
